import { jsx as o } from "react/jsx-runtime";
import { useMemo as A } from "react";
import l from "./styles.module.less.js";
import { MobileMenu as E } from "./mobile.js";
import { DesktopMenu as N } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as M, canLanguageUseAtticus as L } from "../../../constants.js";
import { useScreenSize as _, WidthType as f } from "../../../utils/use-is-mobile.js";
const O = "FLOATING_CONTAINER_ID", g = "MENU_HEADER_ID", S = (d) => {
  const {
    isAuthenticated: t,
    openAuthModal: r,
    userImage: n,
    logout: i,
    hasNotifications: s,
    language: e = M,
    getTranslation: a,
    isLawyerSupported: u,
    lmpEnabled: m,
    onRequestLawyer: c
  } = d, p = A(() => L(e) ? e : void 0, [e]);
  return _() === f.Mobile ? /* @__PURE__ */ o("div", { className: l.mobileMenuWrapper, children: /* @__PURE__ */ o(
    E,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      lmpEnabled: m,
      onRequestLawyer: p ? c : void 0
    }
  ) }) : /* @__PURE__ */ o("div", { className: l.desktopMenuContainer, id: g, children: /* @__PURE__ */ o(
    N,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      lmpEnabled: m,
      onRequestLawyer: p ? c : void 0
    }
  ) });
};
export {
  O as FLOATING_CONTAINER_ID,
  g as MENU_HEADER_ID,
  S as MenuComponent
};
